/**
 * AscendingK — The Connekted.in logo mark (Ascending K identity system v.04)
 * SVG specs: viewBox 0 0 80 100, stem 14×80, steps 14×12
 *
 * @param {number} size - Width of the logo (height auto-calculates at 1.25x)
 * @param {string} color - Fill color for the mark
 */
export default function AscendingK({ size = 40, color = "#0A2540" }) {
  return (
    <svg
      width={size}
      height={size * 1.25}
      viewBox="0 0 80 100"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Connekted.in logo"
    >
      {/* Stem */}
      <rect x="0" y="10" width="14" height="80" fill={color} />
      {/* Ascending steps (top arm) */}
      <rect x="22" y="40" width="14" height="12" fill={color} />
      <rect x="40" y="28" width="14" height="12" fill={color} />
      <rect x="58" y="16" width="14" height="12" fill={color} />
      {/* Descending steps (bottom arm) */}
      <rect x="22" y="48" width="14" height="12" fill={color} />
      <rect x="40" y="60" width="14" height="12" fill={color} />
      <rect x="58" y="72" width="14" height="12" fill={color} />
    </svg>
  );
}
